import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import ColumnHeader from './UIs/ColumnHeader';
import { setGroupColumnOrder, setGroupColumn } from '../../../flow/actions';

const defaultProps = {};
const propTypes = {
  options: PropTypes.array.isRequired,
  sortOnCurrentColumn: PropTypes.bool.isRequired
};

class GroupColumnHeader extends PureComponent {
  handleDropdownChange = val => this.props.setGroupColumn(this.props.id, val);
  handleOrderClick = nextOrder =>
    this.props.setGroupColumnOrder(this.props.id, nextOrder);

  render() {
    const {
      options,
      selectedValue,
      sortOrder,
      sortOnCurrentColumn
    } = this.props;
    return (
      <ColumnHeader
        onDropdownChange={this.handleDropdownChange}
        onOrderClick={this.handleOrderClick}
        options={options}
        selectedValue={selectedValue}
        sortOrder={sortOrder}
        sortOnCurrentColumn={sortOnCurrentColumn}
      />
    );
  }
}

// Utils
const reduceOptions = (data, fieldsMetaData) => {
  // !!! too many dependencies
  if (
    _.isEmpty(data) ||
    _.isEmpty(fieldsMetaData) ||
    !_.isArray(data.groupsZone)
  ) {
    return [];
  }

  const options = data.groupsZone.map(g => {
    const name = g.field_name;
    const field = fieldsMetaData.find(f => f.name === name && f.objectType === data.type) || {};

    return {
      key: name,
      action: 'group',
      name,
      label: !_.isEmpty(field) ? (g.type ? `${field.label} (${g.type})` : field.label) : name,
      restriction: !_.isEmpty(field) ? field.restriction : false,
      deleted: _.isEmpty(field),
    };
  });
  return options;
};

const mapStateToProps = ({ metaData, global, dashboardSettings }, ownProps) => {
  // find slot data by id
  const { id } = ownProps;
  const slotData = dashboardSettings.details.slots.find(s => s.id === id) || {};

  const { reportId } = slotData;
  const report = metaData.reports.data.find(r => r.id === reportId);

  // get options by report settings
  const options = reduceOptions(report, metaData.fields.data);

  // sorted column
  // TODO: revise
  const sortOnCurrentColumn = slotData.orderSettings
    ? slotData.groupSettings === slotData.orderSettings.field_name
    : false;

  return {
    lang: global.language,
    options,
    selectedValue: slotData.groupSettings,
    // TODO: revise
    sortOrder: sortOnCurrentColumn
      ? slotData.orderSettings && slotData.orderSettings.direction
      : null,
    sortOnCurrentColumn
  };
};
const mapDispatchToProps = {
  setGroupColumnOrder,
  setGroupColumn
};
GroupColumnHeader.defaultProps = defaultProps;
GroupColumnHeader.propTypes = propTypes;
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GroupColumnHeader);



// WEBPACK FOOTER //
// ./src/views/DashboardSettings_Slot/components/Table/components/GroupColumnHeader.jsx